const containerWidth = 1366;

export default containerWidth;



// WEBPACK FOOTER //
// ./src/common/consts/containerWidth.js